import FigureLineChart from "./FigureLineChart.Container";

export default FigureLineChart;